import theme from "@/constants/theme";

export const styles: Record<string, React.CSSProperties> = {
  container: {
    backgroundColor: "inherit",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    position: "relative",
  },
  imageStyle: {
    backgroundColor: theme.colors.background.primary,
    width: "auto",
    height: 200,
    objectFit: "cover",
  },
  headerComponent: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "inherit",
    gap: 16,
    flex: 1,
  },
  headerTextContainer: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "inherit",
    gap: 16,
    padding: 16,
  },
  headerTitle: {
    color: theme.colors.text.title,
  },
  headerDescription: {
    color: theme.colors.text.body,
  },
  stepsItems: {
    margin: "4px 16px",
    color: theme.colors.primary,
    fontWeight: "bold",
  },
  startButton: {
    margin: 16,
    marginTop: 0,
    backgroundColor: theme.colors.primary,
    padding: "8px 16px",
    borderRadius: 32,
  },
  startButtonText: {
    color: theme.colors.text.contrast,
    textAlign: "center",
    fontSize: 16,
    fontWeight: "bold",
  },
};
